const env ={
    HOST:"www.getreliable.com/studentaccident",
    LanguageURL:"https://www.getreliable.com/studentaccident",
    PORT:"80",
    REACT_APP_ENV:"PROD",
    REACT_APP_API_URL:"https://api.orican.com/Travel",
    REACT_APP_API_TIMEOUT:"40000",
    REACT_APP_NAME:"Student Accident",
    REACT_APP_AUTH_BASE_URL:"https://funcapp-studentacc-01.azurewebsites.net",
    REACT_APP_AUTH_ENDPOINT:"/api/TokenIssuer?code=a7ZQqJjj2ZO7DmcDeA6GJXkcto8GzTCLd96eHp0ZKV0HAzFuRbA1kQ==",
    REACT_APP_AI_CONNECTION_STRING:"InstrumentationKey=f85095dd-3dcc-44b5-b677-ce787187ea4a;IngestionEndpoint=https://canadacentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://canadacentral.livediagnostics.monitor.azure.com/",
    REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID:"UA-2411516-10",
    REACT_APP_BYPASS_PROCEED_PAYMENT_VALIDATION:"false",
    REACT_APP_MAXAGE:"26",
    REACT_APP_MINAGE:"6",
    REACT_APP_MAXPOLICY:"6",
    GENERATE_SOURCEMAP:"false"
}
export default env;